<!--  -->
<template>
  <div ref="commentCard" class="comment-card">
    <div class="item">
      <!--评价信息-->
      <div
        class="card-content"
        v-track="{
          act: 'show',
          params: {
            cfrom: '105|003|02|077',
            event_id: '105|003|02|077',
            taskType: 1,
            comment_id: remarkItem.commentId,
            sku_id: remarkItem.skuId,
            stateval: !!(remarkItem.commentListPics && remarkItem.commentListPics[0].videoUrl) ? 1 : 2
          }
        }"
      >
        <!--用户个人信息-->
        <UserInfo :user-info="remarkItem" type="list" :origin="2" />
        <!-- 评价图片 -->
        <div class="img-box" v-if="picList && picList.length > 0">
          <ul :class="['img-list', picList.length == 4 ? 'img-box-four' : '']">
            <li
              ref="remarkImg"
              :class="[
                'mask',
                picList.length <= 3 ? 'img-one-line' : 'img-two-line',
                picList.length == 5 ? 'img-five' : ''
              ]"
              tabindex="0"
              v-for="(iItem, iIndex) in picList"
              :key="iIndex"
              :index-data="'cimg' + (iIndex + 1)"
              @click="previewAll(iIndex, remarkItem)"
              v-track="[
                {
                  act: 'click',
                  params: {
                    cfrom: '106|003|01|077',
                    event_id: '106|003|01|077',
                    content: remarkItem.commentId,
                    taskType: 2,
                    stateval: !!picList[0].videoUrl ? 1 : 2
                  }
                }
              ]"
            >
              <img v-lazy="iItem.smallPic" :class="[picList.length <= 2 ? 'img-big' : 'img-little']" alt="评价图片" />
              <template v-if="iIndex == 0 && iItem.videoUrl && isAppSupportVideo">
                <div class="video-play" aria-label="播放视频"></div>
                <div class="video-time" :aria-label="`视频时长${iItem.videoTime / 1000}秒`">
                  {{ iItem.videoTime | formatTime }}
                </div>
              </template>
            </li>
          </ul>
          <div class="total" v-if="remarkItem.commentListPics.length > 6 && remarkItem.showImgeTotal">
            <span>+{{ remarkItem.commentListPics.length - 6 }}张</span>
          </div>
        </div>
        <div class="oth">
          <div class="statis">
            {{ remarkItem.commentDate | formatDate(null, 1) }}
            <span class="buy-number">{{ remarkItem.orderCountDesc }}</span>
          </div>
          <div
            tabindex="0"
            :aria-label="`点赞数${remarkItem.likeNum}-双击可点赞`"
            @click="upvote(remarkItem)"
            :class="`more-${remarkItem.myLike}`"
          >
            <div class="like-point"></div>
            <span class="up-num" :class="remarkItem.likeNum != 0 ? '' : 'up-hiddle'">
              {{ remarkItem.likeNum }}
            </span>
          </div>
        </div>
        <!-- 追评 -->
        <template v-if="remarkItem.commentAppendDto">
          <p class="reply-tit" v-if="remarkItem.commentAppendDto.dayAfterComment > 0">
            {{ remarkItem.commentAppendDto.dayAfterComment }}天后追评
          </p>
          <p class="reply-tit" v-else>当天追评</p>
          <p class="reply-cut" v-text="remarkItem.commentAppendDto.content"></p>
          <div class="img-box">
            <ul
              :class="[
                'img-list',
                remarkItem.commentAppendDto.commentListPics && remarkItem.commentAppendDto.commentListPics.length == 4
                  ? 'img-box-four'
                  : ''
              ]"
              v-if="
                remarkItem.commentAppendDto.commentListPics && remarkItem.commentAppendDto.commentListPics.length > 0
              "
            >
              <li
                ref="appendImg"
                :class="[
                  'mask',
                  remarkItem.commentAppendDto.commentListPics.length <= 3 ? 'img-one-line' : 'img-two-line',
                  remarkItem.commentAppendDto.commentListPics.length == 5 ? 'img-five' : ''
                ]"
                v-for="(rItem, rIndex) in getTopPics(remarkItem.commentAppendDto.commentListPics)"
                :key="rIndex"
              >
                <img
                  v-lazy="rItem.smallPic"
                  :class="[remarkItem.commentAppendDto.commentListPics.length <= 2 ? 'img-big' : 'img-little']"
                  @click="preview(rIndex, remarkItem, rIndex)"
                  alt=""
                />
              </li>
            </ul>
            <div
              class="total"
              v-if="
                remarkItem.commentAppendDto.commentListPics && remarkItem.commentAppendDto.commentListPics.length > 6
              "
            >
              <span>+{{ remarkItem.commentAppendDto.commentListPics.length - 6 }}张</span>
            </div>
          </div>
        </template>
        <template v-for="(reply, index) in remarkItem.commentReplyDtos">
          <div tabindex="0" class="official" v-if="reply.officialFlag == 1" :key="index">
            <div class="speaker">
              <img src="../../images/vivo.png" />
              官方回复
            </div>
            <div :ref="`contentBox${index}`" :class="!reply.isMore ? 'content-hidden' : 'content'">
              <span :ref="`spanBox${index}`">{{ reply.content }}</span>
            </div>
            <span
              v-if="reply.showBtn && reply.isMore"
              class="more"
              aria-hidden="true"
              @click="reply.isMore = !reply.isMore"
              v-text="'收起'"
            ></span>
            <div
              aria-hidden="true"
              class="openMore"
              v-if="reply.showBtn && !reply.isMore"
              @click="reply.isMore = !reply.isMore"
            >
              <span>...</span>
              <span class="more" v-text="' 展开'"></span>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import UserInfo from '../user-info'
import env from 'utils/clientEnv'
function numToStr(num) {
  if (num < 10) {
    return '0' + num
  } else {
    return '' + num
  }
}
export default {
  name: 'CommentCard',
  //import引入的组件需要注入到对象中才能使用
  components: {
    UserInfo
  },
  props: {
    remarkItem: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  filters: {
    formatTime(val) {
      let sec = Math.floor(val / 1000)
      return numToStr(parseInt(sec / 60)) + ':' + numToStr(parseInt(sec % 60))
    }
  },
  data() {
    //这里存放数据
    return {
      isAppSupportVideo: !env.isVivoApp || env.appVersion >= 3950 || env.isIOSVivoApp, // 判断官网app是否支持评价图片预览
      picList: this.remarkItem?.commentListPics?.slice(0, 6) || []
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 预览所有评价图片
    previewAll(startPosition, remarkItem) {
      this.$emit('previewAll', startPosition, remarkItem)
    },
    upvote(remarkItem) {
      this.$emit('upvote', remarkItem)
    },
    preview(startPosition, remarkItem, idx) {
      this.$emit('preview', startPosition, remarkItem, idx)
    },
    getTopPics(picList) {
      return picList ? picList.slice(0, 6) : []
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$nextTick(() => {
      // 判断是否显示展开收起按钮
      this.remarkItem.commentReplyDtos?.forEach((el, index) => {
        if (el.officialFlag == 1 && this.$refs[`spanBox${index}`]?.[0] && this.$refs[`contentBox${index}`]?.[0]) {
          if (this.$refs[`spanBox${index}`][0].offsetHeight > this.$refs[`contentBox${index}`][0].offsetHeight) {
            this.$set(this.remarkItem.commentReplyDtos[index], 'showBtn', true)
            this.$set(this.remarkItem.commentReplyDtos[index], 'isMore', false)
          }
        }
      })

      // 判断是否显示图片总数
      if (this.$refs.commentCard && env.isPadVivoApp) {
        // 显示评价的图片总数
        let length = this.$refs.remarkImg?.reduce((pre, el) => {
          return pre + el.clientWidth
        }, 0)
        if (this.$refs.remarkImg && this.$refs.commentCard.clientWidth <= length) {
          this.$set(this.remarkItem, 'showImgeTotal', true)
        }
        // 显示追评的图片总数
        let appendLength = this.$refs.appendImg?.reduce((pre, el) => {
          return pre + el.clientWidth
        }, 0)
        if (this.$refs.appendImg && this.$refs.commentCard.clientWidth <= appendLength) {
          this.$set(this.remarkItem.commentAppendDto, 'showImgeTotal', true)
        }
      } else {
        this.$set(this.remarkItem, 'showImgeTotal', true)
        if(this.remarkItem.commentAppendDto){
          this.$set(this.remarkItem.commentAppendDto, 'showImgeTotal', true)
        }
      }
    })
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped src="./index.scss"></style>
